import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetProducts } from "./useGetProducts"
import { ProductEntity } from "../../Objects/ProductsAndCatalogItems/ProductEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"
import { useUpgradePlan } from "../../context/useUpgradePlanContext"
import { isPlanLimitError } from "../../utils/planLimits"

export const useSaveProducts = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetProducts } = useGetProducts()

  const { openPlan } = useUpgradePlan()

  const handleSavesProducts = async (productsChange: ProductEntity, onSuccess: any, imageFile?: any | null) => {
    try {
      enableLoad()

      var response = null

      if (productsChange.id !== -1) {
        response = await PutFormRequest(`${API_ROUTES.PRODUCT.PUT}/${productsChange.id}`, productsChange.toJSON(imageFile))
      } else {
        response = await PostFormRequest(API_ROUTES.PRODUCT.CREATE, productsChange.toJSON(imageFile))
      }

      if (response.success) {
        await handleGetProducts(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      if (isPlanLimitError(message)) {
        openPlan()
      }

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSavesProducts,
  }
}
